import { render } from "./NewInputFieldPhone.vue.ts?vue&type=template&id=071477fa&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NewInputFieldPhone.vue?vue&type=template&id=071477fa&scoped=true&ts=true"
import script from "./NewInputFieldPhone.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NewInputFieldPhone.vue?vue&type=script&lang=ts"
export * from "./NewInputFieldPhone.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NewInputFieldPhone.vue?vue&type=script&lang=ts"

import "./NewInputFieldPhone.vue.scss?vue&type=style&index=0&id=071477fa&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NewInputFieldPhone.vue?vue&type=style&index=0&id=071477fa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071477fa"],['__file',"src/apps/person-registration/shared-components/input-fields/NewInputFieldPhone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "071477fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('071477fa', __exports__)) {
    api.reload('071477fa', __exports__)
  }
  
  module.hot.accept("./NewInputFieldPhone.vue.ts?vue&type=template&id=071477fa&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NewInputFieldPhone.vue?vue&type=template&id=071477fa&scoped=true&ts=true", () => {
    api.rerender('071477fa', render)
  })

}


export default __exports__